import React, { useRef, useState, useEffect } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  SafeAreaView,
  Image,
  ImageBackground,
  TextInput,
} from "react-native";
import { useRecoilState } from "recoil";
import { tokenState } from "../reducer/reducer/reducer/Atom";
import { apiservice } from "../service/service";
const { width, height } = Dimensions.get("window");

export default function admin({ navigation }) {
  const [token, setToken] = useRecoilState(tokenState);
  const [profile, setProfile] = useState({});
  useEffect(() => {
    getMyProfile(token);
  }, [token]);

  async function getMyProfile(token) {
    const response = await apiservice({
      path: "/user/getuser",
      method: "get",
      token: token?.accessToken,
    });

    if (response.status == 200) {
      if (response.data.data != null) {
        setProfile(response.data.data);
      } else {
        console.log("g-hk");
        navigation.navigate("Login");
      }
    } else {
      navigation.navigate("Login");
    }
  }
  return (
    <View style={styles.container}>
      <View style={{ flexDirection: "row" }}>
        <Text style={styles.text}>{profile?.username}</Text>
        <Image
          style={styles.img}
          source={{
            uri:
              
              profile?.image_Profile,
          }}
        />
      </View>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    width: "100%",
    height: 50,
    backgroundColor: "#FCC81D",
    marginVertical: 10,
    borderRadius: 10,
    alignItems: "flex-end",
    justifyContent: "center",
  },
  text: {
    fontFamily: "Prompt-Regular",
    fontSize: 20,
    alignSelf: "center",
  },
  img: {
    width: 36,
    height: 36,
    alignSelf: "center",
    borderRadius: 18,
  },
});
